import { stringToArrayDelimiter } from '../transformCellValue/transformCellValueToString/constants';

export const transformStringToStringArray = (str: string): string[] => {
  return str.split(stringToArrayDelimiter).map((s) => s.trim());
};
